import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class LoaderComponent {
    @Input() loading: boolean = false;
    @Input() overlay: boolean = true;
}